import { isMobile } from 'react-device-detect';
import { Navigate, useParams } from 'react-router-dom';

import { useIsManager } from '~modules/auth/model';
import { SessionEnd } from '~pages/manager/SessionEnd/SessionEnd.tsx';
import { Notmobile } from '~pages/manager/notmobile.tsx';
import { routerKeys } from '~shared/router';

export function EndPage() {
	const { id: userId } = useParams<{ id: string }>();
	const isManager = useIsManager();

	if (!isMobile) return <Notmobile />;
	if (!isManager) return <Navigate to={routerKeys.denied()} />;

	if (!userId) return <Navigate to={routerKeys.page404()} />;

	return (
		<>
			<h3>Завершить смену</h3>
			<SessionEnd userId={userId} />
		</>
	);
}
